import { useReducer } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import effects from 'app/effects/effects'
import * as authActions from 'app/auth/store/actions'
import MessageAlert from 'app/components/MessageAlert'

const actionTypes = {
  SUBMIT_INIT: 'SUBMIT_INIT',
  SUBMIT_SUCCESS: 'SUBMIT_SUCCESS',
  SUBMIT_FAIL: 'SUBMIT_FAIL',
  CLOSE_DIALOG: 'CLOSE_DIALOG',
  OPEN_DIALOG: 'OPEN_DIALOG',
  START_LOADING: 'START_LOADING',
  DELETE_SUCCESS: 'DELETE_SUCCESS',
  DELETE_ERROR: 'DELETE_ERROR',
}

const initialState = {
  isLoading: false,
  error: undefined,
  isOpenDialog: false,
}
const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SUBMIT_INIT: {
      return {
        ...state,
        isLoading: true,
        error: undefined,
      }
    }
    case actionTypes.SUBMIT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isOpenDialog: false,
        error: undefined,
      }
    }
    case actionTypes.SUBMIT_FAIL: {
      return {
        ...state,
        isLoading: false,
        error: action.error,
        isOpenDialog: true,
      }
    }
    case actionTypes.CLOSE_DIALOG: {
      return {
        ...state,
        isOpenDialog: false,
      }
    }
    case actionTypes.OPEN_DIALOG: {
      return {
        ...state,
        isOpenDialog: true,
      }
    }
    case actionTypes.START_LOADING: {
      return {
        ...state,
        isLoading: true,
      }
    }
    case actionTypes.DELETE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: undefined,
      }
    }
    case actionTypes.DELETE_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      }
    }

    default: {
      throw new Error('Not supported action')
    }
  }
}
const useSubmitWithDialog = ({
  submitEffect,
  submitEffectSetPassword,
  onSubmitSuccess,
  onError,
}) => {
  const { formatMessage } = useIntl()
  const commonDispatch = useDispatch()

  const [state, dispatch] = useReducer(reducer, initialState)
  const openDialog = () => dispatch({ type: actionTypes.OPEN_DIALOG })
  const closeDialog = () => dispatch({ type: actionTypes.CLOSE_DIALOG })

  const submit = (model) => {
    dispatch({ type: actionTypes.SUBMIT_INIT })
    submitEffect(model)
      .then(() => {
        onSubmitSuccess()
        dispatch({ type: actionTypes.SUBMIT_SUCCESS })
      })
      .catch((error) => {
        onError(error)
        dispatch({ type: actionTypes.SUBMIT_FAIL, error })
      })
  }

  const submitSetPassword = (model) => {
    dispatch({ type: actionTypes.SUBMIT_INIT })
    submitEffectSetPassword(model)
      .then(() => {
        onSubmitSuccess()
        dispatch({ type: actionTypes.SUBMIT_SUCCESS })
      })
      .catch((error) => {
        onError(error)
        dispatch({ type: actionTypes.SUBMIT_FAIL, error })
      })
  }

  const deleted = () => {
    dispatch({ type: actionTypes.START_LOADING })
    effects.apis
      .deactivate()
      .then((response) => {
        dispatch({ type: actionTypes.DELETE_SUCCESS })
        commonDispatch(authActions.logoutUser())
      })
      .catch((error) => {
        dispatch({ type: actionTypes.DELETE_ERROR, payload: error })
        commonDispatch(MessageAlert.showNetworkError(formatMessage)(error))
      })
  }
  return { openDialog, closeDialog, submit, submitSetPassword, state, deleted }
}

export default useSubmitWithDialog
